import React, { useState } from "react";
import {
  validateIsEmail,
  validateIsRequired,
  validateIsTel,
  // validateReplaceNumber,
} from "../../helpers/validateInput";

export default function Input({
  label,
  type: inputType,
  onValidate,
  ...rest
}) {
  const [isValid, setIsValid] = useState(false);
  const [isTouched, setIsTouched] = useState(true);
  const [type, setType] = useState(inputType);
  const id = rest.id || `input-${Math.random().toString(36).substring(7)}`;
  const labelError = rest.labelerror || ""; 

  const validateAll = (value) => {
    switch (type) {
      case "email":
        setIsValid(validateIsEmail(value));
        break;
      case "tel":
        setIsValid(validateIsTel(value));
        break;
      default:
        if (rest.pattern) {
          setIsValid(new RegExp(rest.pattern).test(value));
        } else if (rest.required) {
          setIsValid(validateIsRequired(value));
        } else {
          setIsValid(true);
        }
    }
  };

  const handleChange = (e) => {
    // Reemplazar caracteres no numericos en inputs de tipo tel o number
    // if (type === "tel" || type === "number") {
    //   e.target.value = validateReplaceNumber(e.target.value);
    // }
    validateAll(e.target.value);
    if (rest.onChange) {
      rest.onChange(e);
    }
  };
  const handleFocus = (e) => {
    setIsTouched(true);
  };
  const handleBlur = (e) => {
    validateAll(e.target.value);
    setIsTouched(false);
    if (onValidate) {
      onValidate({
        name: rest.name,
        isValid,
      });
    }
  };

  //   console.log(isValid)

  return (
    <div style={{
      position: 'relative'
    }}>
      {label && <label htmlFor={id}>{label}</label>}
      <input
        className="form-control"
        type={type}
        {...rest}
        onChange={handleChange}
        id={id}
        style={!isValid && !isTouched ? styles.error : {}}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
      {
        inputType === "password" && (
          <aside className="flex-right" style={{
            top: '0px',
            right: '10px',
          }}>
          <button
            onClick={() => setType(type === "password" ? "text" : "password")}
            className="btn-link"
            type="button"
          >
            {type === "password" 
              ? <i className="fa-regular fa-eye"></i>
              : <i className="fa-regular fa-eye-slash"></i>
            }
          </button>
          </aside>
        )
      }
      {!isValid && !isTouched && labelError && (
        <small className="text-danger">{labelError}</small>
      )}
    </div>
  );
}

const styles = {
  error: {
    color: "var(--error)",
    border: "2px solid white",
    outline: '1px solid var(--error)'
  },
};



// WEBPACK FOOTER //
// ./src/components/Input/index.jsx